import { render, staticRenderFns } from "./RecordCourse.vue?vue&type=template&id=3b66775e&scoped=true"
import script from "./RecordCourse.vue?vue&type=script&lang=js"
export * from "./RecordCourse.vue?vue&type=script&lang=js"
import style0 from "./RecordCourse.vue?vue&type=style&index=0&id=3b66775e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b66775e",
  null
  
)

export default component.exports